<div class="main-container" *ngIf="!isDataLoading">
	<h3>Workforce Site Report Request</h3>
  <h5 *ngIf="siteDetails">{{siteDetails.siteName}}</h5>
	<div class="main-form">
		<ng-container *ngIf="!allDates.length && !isDataLoading">
			<p class="email-not-found">
				There are no Completed On Demand Digital Log Forms for the given Id.
			</p>
		</ng-container>

		<ng-container *ngIf="allDates.length">
			<form [formGroup]="reportFormGroup" (keyup)="keyPressed($event)" class="main-form">
        <mat-radio-group
          class="dates-list"
          formControlName="date">
          <mat-radio-button class="example-radio-button" *ngFor="let item of allDates" [value]="item">
						  {{item.date}}
				</mat-radio-button>
			</mat-radio-group>
        <div class="actions" *ngIf="canLoadMoreData">
          <span (click)="loadNextPage()">more...</span>
        </div>
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput formControlName="email" autocomplete="on" name="email" />
				</mat-form-field>

				<p *ngIf="isEmailInvalid" class="email-not-found warning">This email is not allowed to access the
					specified
					report!</p>

				<p *ngIf="isRequestSent" class="email-not-found">Request successfully submitted!</p>

				<div class="form-button-container">
					<button mat-raised-button type="button" (click)="checkEmail()"
						[disabled]="reportFormGroup.invalid || isDataLoading || isRequestSent || isEmailInvalid">Request
						Report</button>
				</div>
			</form>
		</ng-container>
	</div>
</div>

<app-loader [isInline]="true" *ngIf="isDataLoading"></app-loader>